"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRfpCreditSharing = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_rfp_details_entry_entity_1 = require("./opportunity-rfp-details-entry.entity");
let OpportunityRfpCreditSharing = class OpportunityRfpCreditSharing {
};
exports.OpportunityRfpCreditSharing = OpportunityRfpCreditSharing;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCreditSharing.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "opportunity_rfp_details_entry_id",
        type: "integer",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCreditSharing.prototype, "opportunityRfpDetailsEntryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "executive_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCreditSharing.prototype, "executiveId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "credit_sharing_percentage",
        type: "integer",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCreditSharing.prototype, "percentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityRfpCreditSharing.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityRfpCreditSharing.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityRfpCreditSharing.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCreditSharing.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCreditSharing.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_rfp_details_entry_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry !== "undefined" && opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry) === "function" ? _d : Object)
], OpportunityRfpCreditSharing.prototype, "opportunityRfpDetailsEntry", void 0);
exports.OpportunityRfpCreditSharing = OpportunityRfpCreditSharing = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_rfp_credit_sharing" })
], OpportunityRfpCreditSharing);
